import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

/**
 * LocalFooter - Footer for the /local/a/* subdomain pages
 * Simpler than the main B2B footer, focused on local business clients
 */
const LocalFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-muted/50 border-t border-border">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">VGP</span>
              </div>
              <div>
                <span className="font-bold text-foreground">VGP</span>
                <span className="text-muted-foreground ml-1 text-sm">Local</span>
              </div>
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              Simple, affordable marketing for local businesses. More customers, less hassle.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-foreground mb-4">Services</h4>
            <ul className="space-y-2">
              <li><Link to="/local/a/services" className="text-sm text-muted-foreground hover:text-foreground">All Services</Link></li>
              <li><Link to="/local/a/trades" className="text-sm text-muted-foreground hover:text-foreground">For Tradespeople</Link></li>
              <li><Link to="/local/a/restaurants" className="text-sm text-muted-foreground hover:text-foreground">For Restaurants</Link></li>
              <li><Link to="/local/a/salons" className="text-sm text-muted-foreground hover:text-foreground">For Salons</Link></li>
              <li><Link to="/local/a/medical" className="text-sm text-muted-foreground hover:text-foreground">For Medical</Link></li>
              <li><Link to="/local/a/pricing" className="text-sm text-muted-foreground hover:text-foreground">Pricing</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-bold text-foreground mb-4">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-muted-foreground hover:text-foreground">About VGP</Link></li>
              <li><Link to="/local/a/get-started" className="text-sm text-muted-foreground hover:text-foreground">Get a Quote</Link></li>
              <li><Link to="/privacy-policy" className="text-sm text-muted-foreground hover:text-foreground">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="text-sm text-muted-foreground hover:text-foreground">Terms of Service</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-foreground mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href="tel:+447857450763" className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-2">
                  <Phone className="w-4 h-4" />
                  0785 745 0763
                </a>
              </li>
              <li>
                <a href="mailto:evan@vincentgrowthpartners.com" className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-2">
                  <Mail className="w-4 h-4" />
                  evan@vincentgrowthpartners.com
                </a>
              </li>
              <li className="text-sm text-muted-foreground flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                United Kingdom
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © {currentYear} Vincent Growth Partners. All rights reserved.
          </p>
          <p className="text-sm text-muted-foreground">
            Part of <Link to="/" className="text-primary hover:underline">Vincent Growth Partners</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LocalFooter;